<script lang="ts">
  export default {
    name: 'ExportButton',
  };
</script>

<script setup lang="ts">
import { StoreMutationType } from '@/types/StoreMutationType';
import { Download } from '@lucide/vue';
import { computed,  inject, } from 'vue';
import { Store } from 'vuex';
import { AppState } from '@/store';

// ---------------
// reactive data
// ---------------
const store = inject<Store<AppState>>('store');

// ----------
// computed
// ----------
const exportListShowing = computed<boolean | undefined>(() => {
  return store?.state.towerCanvasState.showExportOptions;
});

// ----------
// handlers
// ----------
function  toggleExportOptions(e: MouseEvent): void {
  e.stopPropagation();
  store?.commit(StoreMutationType.SHOW_TOWER_EXPORT_OPTIONS, !store?.state.towerCanvasState.showExportOptions);
}
</script>

<template>
  <div class="py-2 self-end">
    <label title="Export">
      <input
        type="checkbox"
        name="export-button"
        aria-label="Export Button"
        class="box-border pointer-events-none hidden"
        @click="toggleExportOptions"
      />
      <div :class="{ selected: exportListShowing }"
              class="button toggle-button flex items-center justify-center cursor-pointer pointer-events-auto
              border-box rounded-lg shadow-lg w-10 h-10">
          <Download :size="18" />
      </div>
    </label>
  </div>
</template>
  
<style scoped>
.toggle-button {
  background-color: var(--tower-v2-alt-bg-color);
  border: 1px solid var(--tower-v2-border-color);
}

.selected {
  background-color: var(--tower-v2-tool-selected-color);
}

.button:hover {
  background-color: var(--tower-v2-hover-color);
}
</style>
  
